import icon from "~/components/ui/icons/svg/tick.svg";

export const TickIcon = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => {
  return (
    <div className={className}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
        fill={color ?? "white"}
      >
        <use xlinkHref={`#${icon}`} />
      </svg>
    </div>
  );
};
